class SwishOnlineController extends AbstractIntegrationController
	@register()
	@inject 'configuration'

	integrationId: 'swish_online'

	initialize: ->
		@actions =
			disconnect: true
			save: false

	save: ->
		super(@configuration, true).then (response) =>
			@configuration = response.data

	afterDisconnect: ->
		@configuration =
			is_active: false

	isSaveButtonEnabled: ->
		if @saving || !@mainForm.$valid
			return false

		isCertificateMissing = !@configuration.certificate_file
		isActive = @configuration.is_active
		isFormPristine = @mainForm.$pristine

		if isCertificateMissing && !isActive
			return false

		if isCertificateMissing && isActive && isFormPristine
			return false

		return true
